// extracted by mini-css-extract-plugin
module.exports = {"root":"spinner_root__WNhYw","spinner":"spinner_spinner__ZOSZE"};